module.exports = __webpack_public_path__ + "img/360-konferensrum-1.f4a6e9fc.jpg";